import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import SubscribeCard from '@/pages/LandingPage/Pricing/components/SubscribeCard';
import PricingCards from '@/pages/LandingPage/Pricing/components/PricingCards';

const Pricing = forwardRef<HTMLDivElement, { scrollToSection: (_id: string) => void }>(
  ({ scrollToSection }, ref) => {
    return (
      <section
        ref={ref}
        className="min-h-screen bg-[#f5f0ff] flex flex-col items-center justify-center px-6 py-24"
      >
        <motion.div
          className="text-center mb-14"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          viewport={{ once: true }}
        >
          <h2 className="text-[--primary-color] font-bold text-4xl md:text-5xl mb-3">
            Planos e Preços
          </h2>
          <p className="text-[--terciary-color] text-lg font-light">
            Um investimento que garante mais vendas em menos tempo
          </p>
        </motion.div>

        <div className="w-full max-w-5xl grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
          <SubscribeCard scrollToSection={scrollToSection} />
          <PricingCards />
        </div>
      </section>
    );
  }
);

export default Pricing;
